import type { ReactNode } from 'react';
import styles from './StatusNote.module.css';

interface StatusNoteProps {
  tone?: 'note' | 'error';
  children: ReactNode;
}

export const StatusNote = ({ tone = 'note', children }: StatusNoteProps) => (
  <p className={styles.statusNote} data-tone={tone}>
    {children}
  </p>
);
